import Swiper, { Autoplay } from 'swiper'; 
Swiper.use([Autoplay]);

export default class PhoneSliderSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-swiper-slider-swiper]');
        this.swiper = null;

        return true;
    }

    init() {
        this.initSwiper();
        console.log(this.slider);
    }

    initSwiper() {
        if (!this.slider) return;

        this.swiper = new Swiper(this.slider, {
            slidesPerView: 'auto',
            autoplay: {
                delay: 2000,
            },
        });
    }
}